export const categories = [
  {
    id: 'cat-1',
    slug: 'parent-child-education',
    name: '亲子教育场景',
    nameEn: 'Parent-Child Education',
    description: '温馨感人的亲子教育时刻，记录成长中的点滴感动，传递家庭教育正能量，包含打屁股等传统教育方式的文化探讨。',
    icon: 'ri-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20scene%20with%20parent%20and%20child%20interacting%20soft%20natural%20lighting%20through%20window%20gentle%20warm%20cream%20and%20beige%20tones%20educational%20moment%20minimalist%20interior%20style%20editorial%20photography%20emotional%20connection&width=800&height=600&seq=cat-parent-child-01&orientation=landscape',
    videoCount: 128,
  },
  {
    id: 'cat-2',
    slug: 'movie-classic-clips',
    name: '影视经典片段',
    nameEn: 'Movie Classic Clips',
    description: '精选国内外经典影视作品中的打屁股名场面，回顾荧幕经典时刻，感受导演用镜头语言讲述故事的独特魅力。',
    icon: 'ri-film-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20aesthetic%20with%20warm%20golden%20film%20projector%20light%20classic%20movie%20reel%20on%20wooden%20table%20soft%20amber%20and%20cream%20tones%20nostalgic%20atmosphere%20artistic%20composition%20editorial%20style&width=800&height=600&seq=cat-movie-02&orientation=landscape',
    videoCount: 96,
  },
  {
    id: 'cat-3',
    slug: 'funny-prank-videos',
    name: '搞笑整蛊视频',
    nameEn: 'Funny Prank Videos',
    description: '轻松搞笑的整蛊打屁股视频合集，朋友间的欢乐互动，让你笑到停不下来的高能片段，解压放松首选。',
    icon: 'ri-emotion-laugh-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20living%20room%20with%20friends%20laughing%20together%20colorful%20pillows%20warm%20natural%20sunlight%20joyful%20atmosphere%20cream%20and%20coral%20accents%20casual%20fun%20editorial%20photography%20happy%20vibe&width=800&height=600&seq=cat-funny-03&orientation=landscape',
    videoCount: 156,
  },
  {
    id: 'cat-4',
    slug: 'school-fun',
    name: '校园趣事',
    nameEn: 'School Fun',
    description: '青葱校园里的趣味打屁股故事，同学之间的搞笑互动，记录那些年我们在学校的欢乐回忆，青春洋溢。',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20classroom%20interior%20with%20wooden%20desks%20sunlight%20streaming%20through%20large%20windows%20warm%20beige%20and%20cream%20tones%20clean%20minimalist%20educational%20space%20soft%20natural%20lighting%20editorial%20style%20peaceful%20atmosphere&width=800&height=600&seq=cat-school-04&orientation=landscape',
    videoCount: 87,
  },
  {
    id: 'cat-5',
    slug: 'family-happy-moments',
    name: '家庭欢乐时刻',
    nameEn: 'Family Happy Moments',
    description: '记录家庭生活中的温馨搞笑打屁股瞬间，亲子互动、夫妻调侃，满满的家庭温暖与欢乐氛围。',
    icon: 'ri-home-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20family%20living%20room%20with%20warm%20ambient%20lighting%20soft%20throw%20blankets%20wooden%20furniture%20gentle%20cream%20and%20terracotta%20tones%20comfortable%20home%20atmosphere%20editorial%20photography%20warm%20and%20inviting%20minimalist%20decor&width=800&height=600&seq=cat-family-05&orientation=landscape',
    videoCount: 112,
  },
  {
    id: 'cat-6',
    slug: 'animation-clips',
    name: '动漫动画片段',
    nameEn: 'Animation Clips',
    description: '经典动漫动画中的打屁股搞笑场景合集，从日漫到国漫，那些让人忍俊不禁的二次元名场面大盘点。',
    icon: 'ri-ancient-gate-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20animation%20art%20studio%20with%20drawing%20tablet%20sketchbooks%20and%20warm%20ambient%20lighting%20creative%20workspace%20soft%20coral%20and%20cream%20tones%20artistic%20atmosphere%20modern%20minimalist%20editorial%20style%20clean%20composition&width=800&height=600&seq=cat-anime-06&orientation=landscape',
    videoCount: 73,
  },
];

export type Category = typeof categories[0];